export { default } from './LogHeaderContent'
